// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initCheckboxTool = function() {
    (function(_super) {
        coffeeExtends(CheckboxTool, _super);
        function CheckboxTool() {
            return CheckboxTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(CheckboxTool, 'checkbox');
        CheckboxTool.label = 'Insert Checkbox Field';
        CheckboxTool.icon = 'checkbox-field';
        CheckboxTool.tagName = 'checkbox';
        CheckboxTool.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;

            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const checkboxHtml = `<cb contenteditable="false">&#9744;</cb><cblbl>Checkbox label</cblbl>&nbsp;`;
            element.content = tip.concat(checkboxHtml, tail);
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor + 16, cursor + 16);
            element.selection(selection);

            callback(true);
        };
        return CheckboxTool;
    })(ContentTools.Tools.LineBreak);
};



// WEBPACK FOOTER //
// ./src/lib/contenttools/checkbox.js